import { useAPIGetPSOverviewSupplies } from 'api/ps/useAPIPengawasSekolah'
import { useTracker } from 'api/tracker/useAPITracker'
import Link from 'next/link'

import { Button } from '@wartek-id/button'
import { numberUtils } from '@wartek-id/fe-toolbox'
import { Icon } from '@wartek-id/icon'
import { Separator } from '@wartek-id/separator'
import { Spinner } from '@wartek-id/spinner'
import { Text } from '@wartek-id/text'

import { useRegionContext } from 'utils/hooks/useRegion'

import useCurrentRegionRatioDemandPS from 'app/hooks/useCurrentRegionRatioDemandPS'
import usePSActiveSelection from 'app/hooks/usePSActiveSelection'

import DataOverview from 'components/DataOverview'
import HorizontalSteps from 'components/HorizontalSteps'
import Panel from 'components/Panel'

const SectionSeleksiPS = () => {
  const { satuEventTrack } = useTracker()
  const { regionDetail } = useRegionContext()
  const { suggestedAhliNumberTotal } = useCurrentRegionRatioDemandPS()
  const { data: responseGetPSOverviewSupplies } = useAPIGetPSOverviewSupplies({
    id: regionDetail.id,
    type: regionDetail.type,
  })
  const {
    isLoading,
    isOnStepPengajuanFormasi,
    isOnStepUndangBCPS,
    isOnStepFinalisasiBCPS,
  } = usePSActiveSelection()

  const onClickStartSelection = () => {
    satuEventTrack({
      event_name: 'click_mulai_pengangkatan_ps',
      event_version: 3,
    })
  }

  return (
    <Panel>
      <div className="p-6 text-center">
        <Text variant="heading-lg" className="text-center">
          Pengangkatan Pengawas Sekolah
        </Text>
      </div>

      <Separator />

      <div className="mx-auto flex flex-col gap-6 p-6">
        <div className="w-[480px] self-center">
          <HorizontalSteps
            variant="compact"
            fullWidth
            steps={[
              {
                label: 'Pengajuan Formasi',
                isActive: isOnStepPengajuanFormasi,
                isDone: isOnStepUndangBCPS || isOnStepFinalisasiBCPS,
              },
              {
                label: 'Undang BCPS',
                isActive: isOnStepUndangBCPS,
                isDone: isOnStepFinalisasiBCPS,
              },
              {
                label: 'Finalisasi BCPS',
                isActive: isOnStepFinalisasiBCPS,
              },
            ]}
          />
        </div>

        <div className="w-[560px] self-center">
          {isLoading && (
            <div className="flex w-full justify-center">
              <Spinner />
            </div>
          )}

          {isOnStepPengajuanFormasi && (
            <div className="flex flex-col gap-4">
              <Text color="subdued" className="text-center">
                Cek Kebutuhan Pengawas Sekolah di daerah Anda, lalu mulai
                seleksi dan pantau prosesnya di sini.
              </Text>

              <div className="w-[380px] self-center">
                <DataOverview
                  centered
                  overviews={[
                    {
                      title: 'Kebutuhan PS',
                      value: numberUtils.delimit(suggestedAhliNumberTotal),
                    },
                    {
                      title: 'BCPS',
                      value: numberUtils.delimit(
                        responseGetPSOverviewSupplies?.totalPreferred ?? 0
                      ),
                    },
                  ]}
                />
              </div>

              <div className="flex justify-center">
                <Link href="/ps/selection" passHref>
                  <Button size="lg" onClick={onClickStartSelection}>
                    Mulai pengangkatan
                    <Icon fontSize="sm" color="inverse" className="ml-1">
                      arrow_forward
                    </Icon>
                  </Button>
                </Link>
              </div>
            </div>
          )}

          {isOnStepUndangBCPS && (
            <div className="flex flex-col gap-4">
              <Text color="subdued" className="text-center">
                Setelah undangan terkirim, Anda dapat menghubungi BCPS untuk
                mengecek apakah mereka bersedia mengikuti seleksi.
              </Text>

              <Link href="/ps/selection" passHref>
                <Button size="lg" className="mx-auto">
                  Lanjutkan
                  <Icon fontSize="sm" color="inverse" className="ml-1">
                    arrow_forward
                  </Icon>
                </Button>
              </Link>
            </div>
          )}

          {isOnStepFinalisasiBCPS && (
            <div className="flex flex-col gap-4">
              <Text color="subdued" className="text-center">
                Pilih BCPS untuk dikonsultasikan dan disetujui oleh Badan
                Kepegawaian Daerah (BKD) dan Kepala Daerah. Mohon persiapkan
                Surat Keputusan (SK) untuk menyelesaikan tahapan.
              </Text>
              <Link href="/ps/selection" passHref>
                <Button size="lg" className="mx-auto">
                  Lanjutkan
                  <Icon fontSize="sm" color="inverse" className="ml-1">
                    arrow_forward
                  </Icon>
                </Button>
              </Link>
            </div>
          )}
        </div>
      </div>
    </Panel>
  )
}

export default SectionSeleksiPS
